/**
 * Created by MinhQuan on 10/6/2016.
 */
angular.module('arctic.tariff.home', ['common.helper', 'pascalprecht.translate'])
    .controller('HomeController', function ($translate, CONSTANTS) {
        let homeCtrl = this;
        homeCtrl.init = function(){
            homeCtrl.installationCountry = CONSTANTS.installationCountry;
            homeCtrl.branding = CONSTANTS.branding;
        };
    });



// WEBPACK FOOTER //
// ./app/home/home.js